<template>
	<el-dialog
		title="预审列表"
		:append-to-body="true"
		:modal-append-to-body="true"
		:close-on-click-modal="falseValue"
		:visible.sync="showDialog"
		:modal="falseValue"
		custom-class="dialog-style list-dialog"
		width="1200px"
		@close="dialogClose"
		v-el-drag-dialog
		v-el-dialog-center
	>
		<div class="cont" style="height: 400px;">
			<vxe-grid
			max-height="410"
				class="is-pointer"
				ref="table-m1"
				v-bind="vxeOption"
        @resizable-change="$vxeTableUtil.onColumnWitchChange"
        @custom="$vxeTableUtil.customHandle"
        @checkbox-change="addDataTable"
        @checkbox-all="checkAll"
        @cell-dblclick="checkWithSubmit"
			>
				<template #form>
					<div class="clearfix screen-btns">
						<div class="fr">
							<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>
							<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
						</div>
					</div>
					<vxe-form class="screen-box" title-width="92px" title-align="right" :data="formData" @submit="searchEvent" @reset="resetEvent">
            <vxe-form-item title="预审名称:" field="precondition">
              <template v-slot>
                <el-input v-model="formData.precondition" size="small" clearable />
              </template>
            </vxe-form-item>
					</vxe-form>
				</template>
				<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
			</vxe-grid>
		</div>
		<label id="labBtn" class="transverse">
			<div class="icon">
				<i class="el-icon-more"></i>
				<i class="el-icon-more"></i>
			</div>
		</label>
		<div class="multipleChoice">
			<el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
				<a class="allDel icon-quanbushanchu" @click="clearChecked()"></a>
				</el-tooltip>
			<div class="list">
				<div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.id">
					<p>{{ checkRow.precondition }}</p>
					<a class="el-icon-close" @click="clearTable1Select(index)"></a>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogPrimary" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import pager from '@/components/pager/index.vue';
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'
export default {
	name: 'saleConfigDialog',
	props: ['visiable', 'multi', 'param'],
	mixins: [selectDialogMixins],
	components: { pager },
	created() {
		this.initSetting();
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
		total(newVal, oldVal) {
			this.$refs.pager.tableDataTotal = newVal
		}
	},
	mounted() {
		this.initTableM1();
	},
	data() {
		var that = this;
		return {
			total: 0,
		// 查询参数
		formData: {
				size: 0,
				current: 1,
				searchCount: false,
				brandName: "",
				itemCode: "",
				itemName: "",
				bigCategoryId: '',
				smallCategoryId: '',
			},
			pageSizes: [10, 20, 100],
			showDialog: true,
			falseValue: false,
			selectMulti: true,
			formData: {usable:1},
			vxeOption: {}
		};
	},
	methods: {
				// 搜索
				searchEvent() {
			this.formData.itemCode = this.searchItemCode
			this.formData.itemName = this.searchItemName
			this.formData.brandName = this.searchBrandName
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.formData.searchCount = false
			this.$refs.pager.reset()  // 重置分页器
			this.flushed()
		},
    saveDialog(){
      const  $grid = this.$refs.table;
      console.log($grid);
      const rows = $grid.getCheckboxReserveRecords(true);
      $grid.clearCheckboxRow();
      console.log(rows);
      console.log("点击确认！！")
      this.$emit("confirm", rows);
      // this.showDialog = false;
    },
		initTableM1() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'sn_preconditions-m1',
				path:'/admin/fwpttenant/getPreconditions',
				// treeNodeUrl: BASIC_PREFIX + '/saleConfig/listChildren',
				param: this.formData,
        method:'post',
				columns: [
					{ type: 'checkbox', width: 48, resizable: false,  },
          {
            title: '预审名称',
            field: 'precondition',
            width: 150,
           
          },
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false
					}
				],
        config: {
          checkboxConfig: {
            checkStrictly: true,
            showHeader: this.selectMulti,
            trigger: 'row'
          }
        }
			};
      this.vxeOption =  initVxeTable(tableOption);
			console.log(this.$vxeTableUtil,"this.$vxeTableUtil值");
		}

	}
};
</script>
<style lang="scss" scoped> 
::v-deep .dialog-style {
    border-radius: 8px;
    top: -80px!important;
	}
	.vxe-grid .vxe-grid--pager-wrapper {
	display: block;
	width: 100%;
	position: fixed;
	bottom: 0px !important;
	position: absolute !important;
	z-index: 9999999;
	background-color: #ffffff;
}

</style>

